/**
 * Block Video — background autoplay
 *
 * Finds all .wp-block-video elements and converts them to silent,
 * looping, autoplay background videos by stripping controls and
 * setting the required attributes.
 */
export default function initBlockVideo() {
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.wp-block-video').forEach((block) => {
			const video = block.querySelector('video');
			if (!video) return;

			video.removeAttribute('controls');
			video.setAttribute('autoplay', '');
			video.setAttribute('muted', '');
			video.setAttribute('loop', '');
			video.setAttribute('playsinline', '');

			// Mute via property as well (required by some browsers to honour autoplay)
			video.muted = true;

			// Trigger play in case the browser has already parsed the element
			video.play().catch(() => {
				// Autoplay blocked — silently ignore
			});
		});
	});
}
